import { Form } from '@mage-ui/components';
import { z } from 'zod';

export const rules = ({ st }) =>
  z
    .object({
      name: Form.InputText.rules.required(
        st('validation.required', { attribute: '' }),
      ),

      phone: Form.InputText.rules.required(
        st('validation.required', { attribute: '' }),
      ),

      document_number: Form.InputText.rules.required(
        st('validation.required', { attribute: '' }),
      ),

      email: Form.InputText.rules
        .required(st('validation.required', { attribute: '' }))
        .email({ message: st('validation.email', { attribute: '' }) }),

      email_confirmation: Form.InputText.rules
        .required(st('validation.required', { attribute: '' }))
        .email({ message: st('validation.email', { attribute: '' }) }),

      topic: Form.Select.rules
        .required(st('validation.required', { attribute: '' }))
        .transform((val) => val?.id)
        .refine((id) => !!id, {
          message: st('validation.required', { attribute: '' }),
        }),

      message: Form.InputText.rules.required(
        st('validation.required', { attribute: '' }),
      ),

      document_file: z
        .any()
        .optional()
        .nullable()
        .refine(
          (file) => {
            if (!file) {
              return true;
            }
            const name = file?.name || '';
            const ext = name.split('.').pop()?.toLowerCase() || '';
            return ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'].includes(ext);
          },
          { message: st('validation.file_type', { attribute: '' }) },
        )
        .refine(
          (file) => {
            if (!file) {
              return true;
            }
            const size = file?.size ?? 0;
            return size <= 2048 * 1024;
          },
          { message: st('validation.file_size', { attribute: '' }) },
        ),

      accept_privacy: z
        .boolean()
        .default(false)
        .refine((val) => val === true, {
          message: st('validation.required', { attribute: '' }),
        }),
    })
    .superRefine((data, ctx) => {
      if (data.email !== data.email_confirmation) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: st('validation.confirmed', { attribute: '' }),
          path: ['email_confirmation'],
        });
      }
    });
